/* Eya Clean Pro — Scroll & Interactive Animations */

document.addEventListener('DOMContentLoaded', () => {
  initThemeAnimations();
});

// Support Shopify Theme Customizer Live Preview updates
document.addEventListener('shopify:section:load', () => initThemeAnimations());
document.addEventListener('shopify:section:select', () => initThemeAnimations());
document.addEventListener('shopify:section:reorder', () => initThemeAnimations());

function initThemeAnimations() {
  initPhilosophyReveal();
  initBeforeAfterSliders();
  initApplicationsSwitcher();
}

function initPhilosophyReveal() {
  const statement = document.querySelector('.philosophy-statement');
  if (!statement) return;

  const lines = statement.querySelectorAll('span');
  if (!('IntersectionObserver' in window)) {
    lines.forEach(line => line.classList.add('is-visible'));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        lines.forEach((line, index) => {
          setTimeout(() => line.classList.add('is-visible'), index * 250);
        });
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.2 });

  observer.observe(statement);
}

function initBeforeAfterSliders() {
  document.querySelectorAll('.before-after-container').forEach(container => {
    const handle = container.querySelector('.before-after-handle');
    const afterWrapper = container.querySelector('.before-after-after-wrapper');
    const afterImg = afterWrapper ? afterWrapper.querySelector('.before-after-img') : null;
    if (!handle || !afterWrapper) return;

    const setPosition = (clientX) => {
      const rect = container.getBoundingClientRect();
      let pos = (clientX - rect.left) / rect.width;
      pos = Math.max(0.05, Math.min(0.95, pos));
      
      const percent = pos * 100;
      handle.style.left = percent + '%';
      afterWrapper.style.width = percent + '%';
      if (afterImg) afterImg.style.width = rect.width + 'px';
    };

    let isDown = false;
    const onMove = (e) => {
      if (!isDown) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(clientX);
    };

    const onStart = (e) => {
      isDown = true;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setPosition(clientX);
    };

    const onEnd = () => { isDown = false; };

    container.addEventListener('mousedown', onStart);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseup', onEnd);

    container.addEventListener('touchstart', onStart, { passive: true });
    window.addEventListener('touchmove', onMove, { passive: true });
    window.addEventListener('touchend', onEnd);

    if (window.ResizeObserver) {
      const resizeObserver = new ResizeObserver(() => {
        const rect = container.getBoundingClientRect();
        if (afterImg) afterImg.style.width = rect.width + 'px';
      });
      resizeObserver.observe(container);
    }
  });
}

function initApplicationsSwitcher() {
  document.querySelectorAll('[data-applications-section]').forEach(section => {
    const buttons = section.querySelectorAll('.app-btn');
    const previewImg = section.querySelector('.app-preview-img');
    const captionTitle = section.querySelector('.app-caption-title');
    const captionDesc = section.querySelector('.app-caption-desc');

    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');

        if (previewImg && btn.dataset.image) {
          previewImg.style.opacity = '0';
          setTimeout(() => {
            previewImg.src = btn.dataset.image;
            previewImg.style.opacity = '1';
          }, 180);
        }

        if (captionTitle && btn.dataset.title) {
          captionTitle.textContent = btn.dataset.title;
        }
        if (captionDesc && btn.dataset.desc) {
          captionDesc.textContent = btn.dataset.desc;
        }
      });
    });
  });
}
